import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { transferScheduleReducer, initialState } from './transferSchedule.reducer';
import { TransferScheduleContextType } from './transferSchedule.types';

const TransferScheduleContext = createContext<TransferScheduleContextType | undefined>(undefined);

export const TransferScheduleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(transferScheduleReducer, initialState);

  return (
    <TransferScheduleContext.Provider value={{ state, transferScheduleDispatch: dispatch }}>
      {children}
    </TransferScheduleContext.Provider>
  );
};

export const useTransferScheduleContext = () => {
  const context = useContext(TransferScheduleContext);
  if (context === undefined) {
    throw new Error('useTransferScheduleContext must be used within a TransferScheduleProvider');
  }
  return context;
};
